import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import FaqListContainer from "../../components/faq/faq-list.container";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import { fetchFaqsStart } from "../../redux/faq/faq.actions";
import { selectFaqsForPreview } from "../../redux/faq/faq.selector";

class FaqPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }
  componentDidMount() {
    const { fetchFaqsStart } = this.props;
    fetchFaqsStart();
  }
  render() {
    const { faqs, isLoading } = this.props;
    const waitForList = isLoading || this.state.isLoading;

    return (
      <div className="page">
        <PageHeaderComponent
          title="FAQs"
          subtitle="Was ich noch wissen wollte..."
        />
        <div className="fragen-container ">
          <FaqListContainer faqs={faqs} isLoading={waitForList} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchFaqsStart: () => dispatch(fetchFaqsStart()),
});

const mapStateToProps = createStructuredSelector({
  faqs: selectFaqsForPreview,
});

export default connect(mapStateToProps, mapDispatchToProps)(FaqPage);
